<template>
  <common-wrap :preview-data="previewData" v-loading="loading">
    <div class="docx-container">
      <div id="docx"></div>
    </div>
  </common-wrap>
</template>

<script>
import common from "@/mixins/common";
import commonWrap from "@/components/commonWrap";
import { defaultOptions, renderAsync } from 'docx-preview';

export default {
  name: "word-preview",
  mixins: [common],
  components: {
    commonWrap
  },
  data() {
    return {
      fileData: ''
    }
  },
  async mounted() {
    const res = await this.getBlobData();
    if (res) {
      this.fileData = res.data;
      this.render();
    }
  },
  methods: {
    /**
     * 渲染函数
     */
    render() {
      const docxOption = Object.assign(defaultOptions, {
        debug: true,
        experimental: true
      });
      renderAsync(this.fileData, document.getElementById('docx'), null, docxOption).then(res => {
        console.log('docx preview success');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.docx-container {
  z-index: 1001;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

#docx {
  margin: 40px auto;
}

::v-deep .docx-wrapper {
  background-color: transparent;
}
</style>
